

























import { Component, Prop, Vue } from 'vue-property-decorator'

import { SkeletonBox } from '@/layouts/components'

import { Item, ItemGroup } from '@/models'

import ItemImage from './ItemImage.vue'

@Component({
  components: {
    ItemImage,
    SkeletonBox
  }
})
export default class ItemImageContainer extends Vue {
  @Prop({ type: Object, required: true })
  readonly item!: Item | ItemGroup

  @Prop({ type: Boolean, default: null })
  readonly shadow!: boolean | null

  @Prop({ type: String, default: 'bottom' })
  readonly shadowSide!: 'bottom' | 'left' | 'right'

  isLoadingImage = true

  checkShowShadow () {
    return !this.isLoadingImage && (
      this.shadow === true ||
      (this.shadow === null && this.$slots.default !== undefined)
    )
  }
}
